import { ThemeEvents } from '@theme/events';

/**
 * <dark-price-display>
 *
 * Variant değişiminde section re-render HTML'inden kendini bulup
 * iç içeriğini günceller. wire-discount-card / installment-card paterniyle aynı.
 */
class DarkPriceDisplay extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    if (this.section) {
      this.section.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    }
  }

  handleVariantUpdate = (event) => {
    const detail = event.detail ?? {};
    const data = detail.data ?? {};

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const html = data.html;
    if (!html) return;

    const replacement = html.querySelector(`dark-price-display[data-block-id="${this.dataset.blockId}"]`);
    if (!replacement) {
      this.hidden = true;
      return;
    }

    const newInner = replacement.querySelector('[data-dark-price-root]');
    const currentInner = this.querySelector('[data-dark-price-root]');
    if (!newInner || !currentInner) return;

    this.hidden = false;
    currentInner.replaceWith(newInner);

    this.dataset.darkPriceUpdating = 'true';
    window.setTimeout(() => {
      delete this.dataset.darkPriceUpdating;
    }, 450);
  };
}

if (!customElements.get('dark-price-display')) {
  customElements.define('dark-price-display', DarkPriceDisplay);
}
